import { useListCarrierRequestsApiV1CarrierRequestsGet } from '#/shared/api/generated/shipment/theCargoShipment'

import { countAcceptedRequests, mapCarrierRequestList } from './map-list-item'
import type { CarrierRequestItem } from './types'

interface UseCarrierRequestsArgs {
  shipmentId?: string
  enabled?: boolean
  dueOnDelivery?: number
  carrierPay?: number
  distanceMiles?: number
}

interface UseCarrierRequestsResult {
  requests: CarrierRequestItem[]
  totalDispatchedByYou: number
  isLoading: boolean
  isError: boolean
}

export function useCarrierRequests({
  shipmentId,
  enabled = true,
  dueOnDelivery,
  carrierPay,
  distanceMiles,
}: UseCarrierRequestsArgs): UseCarrierRequestsResult {
  const query = useListCarrierRequestsApiV1CarrierRequestsGet(
    { shipment_id: shipmentId, size: 100 },
    { query: { enabled: enabled && Boolean(shipmentId) } },
  )
  const items = query.data?.data.items ?? []
  const requests = mapCarrierRequestList(items, {
    dueOnDelivery,
    carrierPay,
    distanceMiles,
  })
  const totalDispatchedByYou = countAcceptedRequests(items)
  return {
    requests,
    totalDispatchedByYou,
    isLoading: query.isLoading,
    isError: query.isError,
  }
}
